// TODO: rewrite all of this to match partner-ui

// config.js
export const LEGAL_ENTITY_UUID = '8ea2c0e0-4139-4e90-9539-1f8b975cae87';
